var hasOwn = Object.prototype.hasOwnProperty;

dmx.Component("repeat", {

  initialData: {
    items: [],
  },

  attributes: {
    repeat: {
      type: [Array, Object, Number],
      default: null,
    },

    key: {
      type: String,
      default: "",
    },

    rerender: {
      type: Boolean,
      default: false,
    },
  },

  events: {
    update: Event,
    updated: Event,
  },

  render: false,

  init (node) {
    this.prevItems = [];
    this.childKeys = new Map();
    this.$template = document.createDocumentFragment();
    this.RepeatItem = dmx.Component("repeat-item");
    while (this.$node.hasChildNodes()) {
      this.$template.appendChild(this.$node.firstChild);
    }
    if (this.props.repeat) {
      this.performUpdate(new Map([['repeat', undefined]]));
    }
  },

  performUpdate (updatedProps) {
    if (updatedProps.has("key")) this._rerender = true;
    if (!updatedProps.has("repeat")) return;

    this.dispatchEvent("update");

    if (this.props.rerender || this._rerender) {
      this._rerender = false;
      this._clear();
    }

    var RepeatItem = this.RepeatItem || dmx.Component("repeat-item");
    this.RepeatItem = RepeatItem;
    var items = dmx.repeatItems(this.props.repeat);

    if (items.length) {
      if (
        !this.props.rerender &&
        this.props.key &&
        items[0].hasOwnProperty(this.props.key) &&
        this.prevItems.length
      ) {
        // keyed repeater (https://github.com/localvoid/kivi/blob/master/lib/vnode.ts#L1320-L1513)
        var key = this.props.key;
        var prevKeys = this.prevItems;
        var nextItems = items;
        var childMap = this.childKeys;
        var aStart = 0;
        var bStart = 0;
        var aEnd = prevKeys.length - 1;
        var bEnd = nextItems.length - 1;
        var i, j, nextPos;

        outer: while (true) {
          // remove same keys from start
          while (prevKeys[aStart] === nextItems[bStart][key]) {
            const nextItem = nextItems[bStart];
            const nextKey = nextItem[key];
            const child = childMap.get(nextKey);
            if (child) child.set(nextItem);
            aStart++;
            bStart++;
            if (aStart > aEnd || bStart > bEnd) {
              break outer;
            }
          }

          // remove same keys at end
          while (prevKeys[aEnd] === nextItems[bEnd][key]) {
            const nextItem = nextItems[bEnd];
            const nextKey = nextItem[key];
            const child = childMap.get(nextKey);
            if (child) child.set(nextItem);
            aEnd--;
            bEnd--;
            if (aStart > aEnd || bStart > bEnd) {
              break outer;
            }
          }

          // move from right to left
          if (prevKeys[aEnd] === nextItems[bStart][key]) {
            const nextItem = nextItems[bStart];
            const nextKey = nextItem[key];
            const child = childMap.get(nextKey);
            if (child) child.set(nextItem);
            this._moveChild(nextKey, prevKeys[aStart]);
            aEnd--;
            bStart++;
            if (aStart > aEnd || bStart > bEnd) {
              break;
            }
            continue;
          }

          // move from left to right
          if (prevKeys[aStart] === nextItems[bEnd][key]) {
            nextPos = bEnd + 1;
            const nextItem = nextItems[bEnd];
            const nextKey = nextItem[key];
            const child = childMap.get(nextKey);
            if (child) child.set(nextItem);
            this._moveChild(nextKey, nextItems[nextPos] && nextItems[nextPos][key]);
            aStart++;
            bEnd--;
            if (aStart > aEnd || bStart > bEnd) {
              break;
            }
            continue;
          }

          break;
        }

        if (aStart > aEnd) {
          // insert rest from b
          nextPos = bEnd + 1;
          var beforeItem = nextItems[nextPos];
          var beforeKey = beforeItem && beforeItem[key];
          while (bStart <= bEnd) {
            this._insertChild(nextItems[bStart++], beforeKey);
          }
        } else if (bStart > bEnd) {
          // remove rest from a
          while (aStart <= aEnd) {
            this._removeChild(prevKeys[aStart++]);
          }
        } else {
          var aLength = aEnd - aStart + 1;
          var bLength = bEnd - bStart + 1;
          var aNullable = prevKeys;
          var sources = new Array(bLength).fill(-1);

          var moved = false;
          var pos = 0;
          var synced = 0;

          if (bLength <= 4 || aLength * bLength <= 16) {
            for (i = aStart; i <= aEnd; i++) {
              if (synced < bLength) {
                for (j = bStart; j <= bEnd; j++) {
                  const nextItem = nextItems[j];
                  const nextKey = nextItem[key];
                  if (prevKeys[i] === nextKey) {
                    sources[j - bStart] = i;

                    if (pos > j) {
                      moved = true;
                    } else {
                      pos = j;
                    }

                    const child = childMap.get(nextKey);
                    if (child) child.set(nextItem);

                    synced++;
                    aNullable[i] = null;
                    break;
                  }
                }
              }
            }
          } else {
            var keyIndex = {};

            for (i = bStart; i <= bEnd; i++) {
              const nextItem = nextItems[i];
              keyIndex[nextItem[key]] = i;
            }

            for (i = aStart; i <= aEnd; i++) {
              if (synced < bLength) {
                j = keyIndex[prevKeys[i]];

                if (j !== undefined) {
                  sources[j - bStart] = i;

                  if (pos > j) {
                    moved = true;
                  } else {
                    pos = j;
                  }

                  const nextItem = nextItems[j];
                  const nextKey = nextItem[key];
                  const child = childMap.get(nextKey);
                  if (child) child.set(nextItem);

                  synced++;
                  aNullable[i] = null;
                }
              }
            }
          }

          if (aLength === prevKeys.length && synced === 0) {
            this._clear();
            while (bStart < bLength) {
              this._insertChild(nextItems[bStart++], null);
            }
          } else {
            i = aLength - synced;
            while (i > 0) {
              if (aNullable[aStart] !== null) {
                this._removeChild(prevKeys[aStart]);
                i--;
              }
              aStart++;
            }

            if (moved) {
              var seq = this._lis(sources);
              j = seq.length - 1;
              for (i = bLength - 1; i >= 0; i--) {
                if (sources[i] === -1) {
                  pos = i + bStart;
                  nextPos = pos + 1;
                  const currentItem = nextItems[pos];
                  const nextSibling = nextItems[nextPos];
                  this._insertChild(currentItem, nextSibling && nextSibling[key]);
                } else {
                  if (j < 0 || i !== seq[j]) {
                    pos = i + bStart;
                    nextPos = pos + 1;
                    const currentItem = nextItems[pos];
                    const nextSibling = nextItems[nextPos];
                    this._moveChild(currentItem[key], nextSibling && nextSibling[key]);
                  } else {
                    j--;
                  }
                }
              }
            } else if (synced !== bLength) {
              for (i = bLength - 1; i >= 0; i--) {
                if (sources[i] === -1) {
                  pos = i + bStart;
                  nextPos = pos + 1;
                  const currentItem = nextItems[pos];
                  const nextSibling = nextItems[nextPos];
                  this._insertChild(currentItem, nextSibling && nextSibling[key]);
                }
              }
            }
          }
        }
      } else {
        var childrenLength = this.children.length;

        if (childrenLength > items.length) {
          for (var removeIndex = items.length; removeIndex < childrenLength; removeIndex++) {
            this.children[removeIndex].$destroy();
          }
          this.children.length = items.length;
          childrenLength = items.length;
        }

        if (childrenLength) {
          for (var updateIndex = 0; updateIndex < childrenLength; updateIndex++) {
            var child = this.children[updateIndex];
            var nextData = items[updateIndex];
            var childData = child.data;

            for (var key in childData) {
              var currentValue = childData[key];
              if (!hasOwn.call(nextData, key) && currentValue && !currentValue.$type) {
                delete childData[key];
              }
            }

            child.set(nextData);
          }
        }

        if (items.length > childrenLength) {
          var fragment = document.createDocumentFragment();
          var toParse = [];

          for (var createIndex = childrenLength; createIndex < items.length; createIndex++) {
            var newChild = new RepeatItem(
              this.$template.cloneNode(true),
              this,
              items[createIndex]
            );
            newChild.$nodes.forEach((node) => {
              fragment.appendChild(node);
            });
            toParse.push(newChild);
            this.children.push(newChild);
          }

          this.$node.appendChild(fragment);

          for (var parseIndex = 0; parseIndex < toParse.length; parseIndex++) {
            var pendingChild = toParse[parseIndex];
            pendingChild.$nodes.forEach((node) => {
              pendingChild.$parse(node);
            });
          }
        }
      }
    } else {
      this._clear();
    }

    if (this.props.key) {
      this.prevItems = this._snapshotKeys(items);
      for (let child of this.children) {
        this.childKeys.set(child.data[this.props.key], child);
      }
    }

    //this.set('items', items);
    this.set(
      "items",
      this.children.map((child) => child.data)
    );

    dmx.nextTick(() => this.dispatchEvent("updated"));
  },

  _lis (a) {
    var p = a.slice(0);
    var result = [];
    result.push(0);
    var u, v;

    for (var i = 0, il = a.length; i < il; i++) {
      if (a[i] === -1) {
        continue;
      }

      var j = result[result.length - 1];
      if (a[j] < a[i]) {
        p[i] = j;
        result.push(i);
        continue;
      }

      u = 0;
      v = result.length - 1;

      while (u < v) {
        var c = ((u + v) / 2) | 0;
        if (a[result[c]] < a[i]) {
          u = c + 1;
        } else {
          v = c;
        }
      }

      if (a[i] < a[result[u]]) {
        if (u > 0) {
          p[i] = result[u - 1];
        }
        result[u] = i;
      }
    }

    u = result.length;
    v = result[u - 1];

    while (u-- > 0) {
      result[u] = v;
      v = p[v];
    }

    return result;
  },

  _clear () {
    this.prevItems = [];
    this.childKeys.clear();
    this.$node.innerHTML = '';
    for (var i = 0; i < this.children.length; i++) {
      this.children[i].$destroy();
    }
    this.children.length = 0;
  },

  _insertChild (data, before) {
    var RepeatItem = this.RepeatItem || dmx.Component("repeat-item");
    this.RepeatItem = RepeatItem;
    var child = new RepeatItem(this.$template.cloneNode(true), this, data);

    child.$nodes.forEach((node) => {
      if (!before) {
        this.$node.appendChild(node);
      } else {
        if (this.childKeys.has(before)) {
          this.$node.insertBefore(node, this.childKeys.get(before).$nodes[0]);
        } else {
          console.warn(
            "(insert) can not insert node before key " + before + "!"
          );
        }
      }

      child.$parse(node);
    });

    this.childKeys.set(data[this.props.key], child);
    this.children.push(child);
  },

  _moveChild (key, before) {
    var child = this.childKeys.get(key);

    if (child) {
      if (this.childKeys.has(before)) {
        child.$nodes.forEach((node) => {
          this.$node.insertBefore(node, this.childKeys.get(before).$nodes[0]);
        });
      } else {
        child.$nodes.forEach((node) => {
          this.$node.appendChild(node);
        });
      }
    } else {
      console.warn("(move) child with key " + key + " not found!");
    }
  },

  _removeChild (key) {
    var child = this.childKeys.get(key);
    if (child) {
      child.$destroy();
      this.children.splice(this.children.indexOf(child), 1);
      this.childKeys.delete(key);
    } else {
      console.warn("(remove) child with key " + key + " not found!");
    }
  },

  _snapshotKeys (items) {
    const snapshot = this.prevItems;
    const key = this.props.key;
    const length = items.length;

    snapshot.length = length;

    for (let i = 0; i < length; i++) {
      snapshot[i] = items[i][key];
    }

    return snapshot;
  },
});
